import React from 'react'
import {FaRegCheckCircle} from "react-icons/fa";
import { motion, AnimatePresence } from 'framer-motion';

const Secrets = ({secrets, textColor, textShadow}) => {
  console.log(secrets)
  return (
    <div>
       {/* What You'll Learn Section */}
       <motion.div 
              whileHover={{ scale: 1.005 }}
              className="bg-white p-8 rounded-xl shadow-lg"
            >
              <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center">
                <FaRegCheckCircle className={`${textColor} mr-3`} />
                {secrets?.headline || "Here's What You'll Learn"}
              </h2>
              <div className="space-y-4">
                {secrets?.items?.map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className={`${textShadow} p-1 rounded-full mr-4 mt-1`}>
                    <FaRegCheckCircle className={`${textColor}`} />
                  </div>
                  <p className="text-gray-700">
                    {item.items || "Lorem ipsum dolor sit amet"}
                  </p>
                </div>
              ))}
             
              </div>
            </motion.div>
    </div>
  )
}

export default Secrets
